<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: 'welcome-demo-list', params: {save: true}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        <strong>{{ funcType }}</strong> 样例
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="名称" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name" required />
        </b-form-group>
        <b-form-group label="代号" label-for="code">
          <b-form-input id="code" type="text" v-model="data.code" :disabled="update" required />
        </b-form-group>
        <b-form-group label="排位" label-for="icon">
          <b-form-input id="sortId" type="number" v-model="data.sortId" min="1" required />
        </b-form-group>
        <b-form-group label="描述" label-for="desc">
          <b-form-radio-group
            v-model="data.ismd"
            :options="briefOptions"
            class="mb-3"
            @change="changeMode"
          />
          <Markdown v-if="data.ismd" ref="descMd" id="desc" :text="data.desc" required />
          <div v-else>
            <b-form-file
              v-model="descFile"
              class="mt-3"
              :placeholder="uploadPlaceholder"
              :browse-text="uploadBrowseText"
              @change="getFileContent"
            />
            <b-card v-if="data.desc" title="当前Html">
              <b-card-text>
                {{ data.desc }}
              </b-card-text>
            </b-card>
          </div>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat" /> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import consts from '@/utils/consts'
import Markdown from './Markdown'

export default {
  name: 'welcome-service-form',
  mixins: [Error],
  props: ['formData', 'func', 'isUpdate'],
  components: {Markdown},
  data () {
    return {
      data: this.formData,
      staticData: JSON.parse(JSON.stringify(this.formData)),
      funcType: this.func,
      update: this.isUpdate,
      briefOptions: consts.BRIEF_OPTIONS,
      descFile: null,
      uploadPlaceholder: consts.UPLOAD_FILE_PLACEHOLDER,
      uploadBrowseText: consts.UPLOAD_FILE_BROWSE_TEXT
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      if ((this.data.ismd && !this.$refs.descMd.mdText) || (!this.data.ismd && !this.data.desc)) {
        this.$message.error('描述不能为空')
        return false
      }
      this.$emit('submitData', this.handleData())
    },
    onReset (evt) {
      evt.preventDefault()
      let ismd = this.data.ismd
      this.data = JSON.parse(JSON.stringify(this.staticData))
      this.data.ismd = ismd
      this.$refs.descMd.mdText = JSON.parse(JSON.stringify(this.staticData)).desc
    },
    handleData () {
      return {
        name: this.data.name,
        code: this.data.code,
        desc: this.data.ismd ? this.$refs.descMd.mdText : this.data.desc,
        ismd: this.data.ismd,
        sortId: this.data.sortId
      }
    },
    changeMode (checked) {
      if (checked === this.staticData.ismd) {
        this.data.desc = this.staticData.desc
        if (checked) {
          this.$refs.descMd.mdText = this.staticData.desc
        }
      } else {
        this.data.desc = ''
        if (checked) {
          this.$refs.descMd.mdText = ''
        }
      }
    },
    getFileContent (event) {
      let self = this
      const reader = new FileReader()
      reader.readAsText(event.target.files[0])
      reader.onload = function () {
        self.data.desc = this.result
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DemoForm.vue?5da54ef5